/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.2",
    versionName: "0.2.0-nightly.2025.7.2",
    versionChannel: "nightly",
    buildDate: "2025-07-02T00:07:33.514Z",
    commitHash: "4ce3faa2e52f868ba9a6ca0e7209de1f32a5a259",
};
